import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { NotificationActions } from './notification.actions';
import {
  selectNotificationError,
  selectNotifications,
  selectNotificationsLoaded,
  selectNotificationsLoading,
  selectUnreadCount,
  selectUnreadNotifications,
} from './notification.selectors';

/**
 * Façade over the notification store. Components read the signals from here; the API service is only
 * ever touched by the effects.
 */
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly store = inject(Store);

  readonly notifications = this.store.selectSignal(selectNotifications);
  readonly unread = this.store.selectSignal(selectUnreadNotifications);
  readonly unreadCount = this.store.selectSignal(selectUnreadCount);
  readonly loaded = this.store.selectSignal(selectNotificationsLoaded);
  readonly loading = this.store.selectSignal(selectNotificationsLoading);
  readonly error = this.store.selectSignal(selectNotificationError);

  load(): void {
    this.store.dispatch(NotificationActions.loadNotifications());
  }

  /**
   * Starts the periodic refresh. Called by the header bell, which is mounted for the whole session,
   * so the badge appears without the user reloading the page.
   */
  startPolling(): void {
    this.store.dispatch(NotificationActions.startPolling());
  }

  stopPolling(): void {
    this.store.dispatch(NotificationActions.stopPolling());
  }

  markRead(id: number): void {
    this.store.dispatch(NotificationActions.markRead({ id }));
  }

  markAllRead(): void {
    this.store.dispatch(NotificationActions.markAllRead());
  }
}
